import { Component, Input, OnInit, OnChanges, input, Output, OnDestroy, SimpleChanges, HostListener } from '@angular/core';
import { EventEmitter } from '@angular/core';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { MatDialog } from '@angular/material/dialog';
import { MenuCopyDialogComponent } from '../menu-copy-dialog/menu-copy-dialog.component';
import { NotificationService } from 'src/app/shared/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { combineLatest, from, map, Observable, of, share, startWith, Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { StockingServiceService } from '../../stocking-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { consumerPollProducersForChange } from '@angular/core/primitives/signals';
import { CanComponentDeactivate } from './pending-changes.guard';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css'
})
export class MenuComponent implements OnInit, OnDestroy, CanComponentDeactivate {

  products$ = new Observable<any>();
  myControl = {};
  mainForm

  isChanged = false;
  exportJsonData = "";

  // Optional note attached to a save. When this save also swaps or removes a
  // product a customer already ordered, the menuProductChanged cloud trigger
  // includes this verbatim in their notification email — see
  // functions/controllers/menuProductChangeNotifier.js. Applies to the whole
  // save, not one row, since one save can contain more than one swap.
  changeReason = '';

  productTypes = {}
  menu$ = new Observable<any>();
  menuSubject$ = new Subject<any>();
  menus$ = new Observable<any>();
  productTypes$ = new Observable<any>();
  categories$ = new Observable<any>();
  menuBar$ = new Subject<any>();
  locked = false;
  hollydayLoading = true;
  hollydays$ = new Observable<any>();
  importJsonDataTextArea = new FormControl<string>('');
  loading = true;
  isAdmin = false;
  products = [];
  days = ['mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag'];
  displayedColumns: string[] = ['product', 'vegan', 'description', 'price', ...this.days, 'total']; // , 'tuesday', 'wednesday', 'thursday', 'friday'
  //
  // Subscriptions
  formControlUpdateSubscription = null;

  menuItems = {};
  stockingSettings$ = new Observable<any>();
  menuItems$ = new Observable<any>();
  menuFilterStrings = {};

  // Temp
  importJsonData = "";
  importedJsonData = null;

  title = 'MenuComponent';

  groupedProducts = {};
  week: moment.Moment;
  currentWeek = moment();
  // OnChangeDate: EventEmitter<string>;

  haveChanges = new EventEmitter<boolean>();

  productType: string;

  constructor(
    private stockingService: StockingServiceService,
    public dialog: MatDialog,
    private notificationService: NotificationService,
    private auth: AuthService,
    private activeRoute: ActivatedRoute,
    private router: Router
  ) {

    const authSub = this.auth.getUser$().subscribe(userInfo => {
      this.isAdmin = userInfo['roles'].admin;
      authSub.unsubscribe();
    });


    let r = this.activeRoute as ActivatedRoute;

    while (r.firstChild) r = r.firstChild;

    r.paramMap.subscribe(pm => {
      const yearStr = pm.get('year');
      const weekStr = pm.get('week');

      const year = yearStr ? parseInt(yearStr, 10) : NaN;
      const week = weekStr ? parseInt(weekStr, 10) : NaN;

      const hasValidParams = !isNaN(year) && !isNaN(week);

      if (hasValidParams) {
        this.week = moment().year(year).week(week).startOf('week').add(1, 'day').startOf('day');
      } else {
        this.week = moment().startOf('week').add(1, 'day').startOf('day');
        this.router.navigate(['dashboard/menus', this.week.format('YYYY'), this.week.format('WW')]);
      }
    });


  }

  ngOnDestroy(): void {
    if (this.formControlUpdateSubscription) this.formControlUpdateSubscription.unsubscribe();
  }

  ngOnInit() {

    this.stockingSettings$ = this.stockingService.getStockingSettings$().pipe(map((snapshot) => {
      return snapshot.data();
    }));

    this.updateMenuList();
    this.initMenu();
    this.updateMenu();

  }

  async updateMenuList() {

    const from = this.week.clone().startOf('week').add(1, 'day').subtract(8, 'weeks').startOf('day');
    const fromWeek = from.week();
    const fromYear = from.year();
    const to = this.week.clone().endOf('week').add(8, 'weeks');
    console.log({ from: from.format('YYYY-MM-DD'), to: to.format('YYYY-MM-DD') });
    const toWeek = to.week();
    const toYear = to.year();
    console.log({ fromWeek, toWeek, fromYear, toYear });

    this.menus$ = this.stockingService.getMenus$(from.unix(), to.unix()).pipe(map(menus => {
      // Add missing menues
      console.log("Filling in missing menus", { menus });

      return Array.from({ length: (to.diff(from, 'weeks') + 1) }, (_, i) => {

        // Using moment to calculate week and year to handle year transitions
        const week = moment(from).add(i, 'weeks').week();
        const year = moment(from).add(i, 'weeks').endOf('week').year();
        const menuExists = menus.find(m => m['week'] == week && m['year'] == year);

        // Empty, draft or locked menu
        const isEmpty = !menuExists;
        const isDraft = menuExists && !menuExists['locked'];
        const isLocked = menuExists && menuExists['locked'];

        const extraText = isLocked ? 'Locked' : isDraft ? 'Draft' : isEmpty ? 'Empty' : '';

        return {
          week,
          year,
          locked: menuExists ? menuExists['locked'] : false,
          menuExists,
          extraText
        };
      });
    }));

    const menusSubscription = combineLatest([this.menus$, this.stockingSettings$]).subscribe(([menus, stockingSettings]) => {
      console.log("Setting up menu bar")
      console.log({ menus, stockingSettings })
      this.menuBar$.next({
        menus,
        stockingSettings
      });
      menusSubscription.unsubscribe();
    }); // Trigger the fetch
  }

  updateMenu() {
    const getMenuSub = this.stockingService.getMenu$(this.week.format('WW'), this.week.format('YYYY')).subscribe((menu) => {
      this.menuSubject$.next(menu);
      getMenuSub.unsubscribe();
    });
  }

  initMenu() {
    // this.loading = true;
    this.updateMenuList();



    this.hollydays$ = this.stockingService.getHollydays$();

    this.products$ = this.stockingService.getProducts$();




    this.categories$ = this.stockingService.getStockingSettings$().pipe(
      map((snapshot) => {
        const settings = snapshot.data() as any;
        return Object.keys(settings['productTypes']).map((key) => settings['productTypes'][key]);
      }), map(a => Array.from(new Set(a))), map(a => a.sort((x, y) => x.localeCompare(y)))
    );


    this.productTypes$ = this.stockingService.getStockingSettings$().pipe(
      map((snapshot) => {
        const settings = snapshot.data() as any;
        return Object.keys(settings['productTypes']).map((key) => key);
      })
    );


    this.menuItems$ = combineLatest([this.products$, this.stockingSettings$, this.menuSubject$, this.hollydays$]).pipe(
      map(([products, settings, menu, hollydays]) => {

        const isEmptyMenu = menu['data'] === undefined;

        const productTypes = Object.keys(settings['productTypes']).sort((a, b) => {
          return a.localeCompare(b)
        }).reduce((acc, key) => {
          acc[key] = settings['productTypes'][key]
          return acc
        }, {});

        const categories = Object.keys(productTypes).reduce((acc, productType) => {
          const category = productTypes[productType]
          if (!acc.includes(category)) {
            acc.push(category)
          }
          return acc;
        }, [])

        const hollydaysThisWeek = [1, 2, 3, 4, 5].map((dayNumber) => {
          const day = this.week.clone().startOf('week').add(dayNumber, 'days').format('YYYY-MM-DD');
          return hollydays.find((h) => h.date.isSame(day, 'day')) || false;
        });

        const dayStrings = [1, 2, 3, 4, 5].map((dayNumber) => {
          const day = this.week.clone().startOf('week').add(dayNumber, 'days');
          return day.format('ddd DD.MM');
        });

        const tmpMenuItems = {
          products: Object.keys(productTypes).reduce((acc, productType) => {
            this.menuFilterStrings[productType] = "";
            acc[productType] = {}

            if (menu['data'] === undefined) {
              acc[productType]["amounts"] = Array(5).fill(0);
              acc[productType]["product"] = null;
            } else {
              acc[productType]["amounts"] = menu['data'] ? menu['data'][productType]?.amounts || Array(5).fill(0) : Array(5).fill(0);
              acc[productType]["product"] = menu['data'] ? menu['data'][productType]?.product || null : null;
            }

            acc[productType]["category"] = productTypes[productType];
            acc[productType]["productType"] = productType;

            // Zero all holiday amounts
            acc[productType]["amounts"] = acc[productType]["amounts"].map((amount, index) => {
              return hollydaysThisWeek[index] ? 0 : amount;
            });

            return acc;
          }, {}),
          hollydaysThisWeek: hollydaysThisWeek,
          dayStrings: dayStrings,
          categories: categories,
          productTypes: productTypes,
          allProducts: products,
          settings: settings,
          locked: !isEmptyMenu ? menu['locked'] : false,
        };




        return tmpMenuItems

      }), share())

    this.formControlUpdateSubscription = combineLatest([this.productTypes$, this.menuItems$]).subscribe(([productTypes, menuItems]) => {

      this.totals = {
        categories: {},
        productTypes: {},
        grandTotal: {
          categories: {
          }, all: 0
        }
      };

      this.totals['categories'] = {};

      productTypes.forEach((productType) => {

        if (!this.myControl[productType]) {
          this.myControl[productType] = {
            product: new FormControl<string>(''),
            total: new FormControl<number>(0),
            amounts: Array.from({ length: 5 }, () => new FormControl<number>(0))
          };
        }

        const menuItem = menuItems.products[productType];

        if (!menuItem) return;

        // Set product
        this.myControl[productType].product.setValue(menuItem.product);

        // Set amounts
        menuItem.amounts.forEach((amount, index) => {
          this.myControl[productType].amounts[index].setValue(amount);
          // this.myControl[productType].amounts[index].disable();
        });


        // Update totals
        const totalForProductType = this.myControl[productType].amounts.reduce((acc, control) => {
          return acc + (control.value || 0);
        }, 0);

        this.totals['productTypes'] = this.totals['productTypes'] || {};
        this.totals['productTypes'][productType] = totalForProductType;

        const category = menuItems.settings['productTypes'][productType];


        // if (!this.totals['categories']) this.totals['categories'] = {};
        // if (!this.totals['categories'][category]) this.totals['categories'][category] = [0, 0, 0, 0, 0];


        // if(category === "baguetter"){
        //   console.log({ category, totals: this.totals['categories'] });
        //   return;
        // }

        // // this.totals['categories'][category] = [0, 0, 0, 0, 0];
        // new Array(5).fill(0).forEach((_, day) => {
        //   console.log({ category, day, amount: (menuItem.amounts[day] || 0) });
        //   this.totals['categories'][category][day] += (menuItem.amounts[day] || 0);
        // });

        // if(category === "baguetter"){
        //   console.log({ category, totals: this.totals['categories'] });
        //   return;
        // }
      });


      if (menuItems.locked) {
        this.locked = true;
        this.lockMenu();
      } else {
        this.unLockMenu(menuItems);
      }

      // Lock all holiday amounts
      if (menuItems.hollydaysThisWeek) {
        Object.keys(this.myControl).forEach((productType) => {
          menuItems.hollydaysThisWeek.forEach((hollyday, index) => {
            if (hollyday) this.myControl[productType].amounts[index].disable();
          });
        });
      }

      const categories = [...new Set(Object.values(menuItems.settings['productTypes']))]

      productTypes.forEach((productType) => {

        const category = menuItems.settings['productTypes'][productType];

        this.amountChanged(null, category, productType, null, menuItems);
      });

      // Grand totals
      this.totals['grandTotal'] = {
        categories: {},
        all: 0
      }
      categories.forEach((category) => {
        this.totals['grandTotal'].categories[category] = this.totals['categories'][category].reduce((a, b) => a + b, 0);
        this.totals['grandTotal'].all += this.totals['grandTotal'].categories[category];
      });

      
      this.isChanged = false;
      this.haveChanges.emit(false);

    });


    return;
  }

  ngOnChanges(change) {
    this.title = this.week.format('WW')
  }

  displayFn(product: any): string {
    return product && product.name ? product.name : '';
  }

  // Select all text when input receives focus
  selectAll(event: FocusEvent) {
    const target = event.target as HTMLInputElement;
    if (!target) return;
    // Timeout ensures Angular/Material focus handling completes before selecting
    setTimeout(() => {
      try { target.select(); } catch (e) { /* ignore */ }
    }, 0);
  }

  // After an option is selected from the autocomplete, re-select the text in the input
  onOptionSelected(event: any, input: HTMLInputElement) {
    if (!input) return;

    this.isChanged = true;
    this.haveChanges.emit(true);

    setTimeout(() => {
      try { input.select(); } catch (e) { /* ignore */ }
    }, 0);
  }

  getFilterdProducts(productType, menuItems) {

    const category = menuItems.productTypes[productType];

    const control = this.myControl[productType]?.product;
    if (!control) {
      // control not yet initialized — return all products once
      return of((menuItems.allProducts || []).slice());
    }

    return control.valueChanges.pipe(
      // start with current control value so the list shows immediately
      startWith(control.value || ''),
      map((value: any) => {
        // value may be a string while typing or an object when an option is selected
        const str = typeof value === 'string' ? value : (value && value.name) ? value.name : '';
        const filterValue = str ? str.toLowerCase() : '';
        // filter and return a new array
        const normalizedCategory = (category || '').trim().toLowerCase();
        const matchingProducts = (menuItems.allProducts || []).filter((product) =>
          product.name.toLowerCase().includes(filterValue) &&
          normalizedCategory &&
          (product.categories || []).some((c) => (c || '').trim().toLowerCase().includes(normalizedCategory))
        ).sort((a, b) => a.name.localeCompare(b.name));

        return matchingProducts;
      })
    );
  }


  importJson(menuItems) {
    try {

      const map = [
        'BAGUETTE A',
        'BAGUETTE B',
        'BAGUETTE C',
        'BAGUETTE D',
        'BAGUETTE E',
        'BAGUETTE HA',
        'BAGUETTE HB',
        'SALAT B',
        'SALAT A',
        'MIDDAG A',
        'MIDDAG B',
        'BURGER A',
        'BURGER B',
        'WRAP A',
        'SUB A',
        'SUB B',
        'YOGHURT A',
        'YOGHURT B',
      ]


      const importData = this.importJsonDataTextArea.value ? this.importJsonDataTextArea.value : '';

      const lines = importData.split('\n').map(line => line.trim()).filter(line => line.length > 0);

      // Filter lines that start with a letter and ends with a number
      const dataLines = lines.filter(line => /^[A-Za-z].*\d$/.test(line));


      map.forEach((productType, index) => {

        const columns = dataLines[index].split('\t').map(col => col.trim());

        // Find in all products
        const product = menuItems.allProducts.find((p) => p.name.toLowerCase().trim() === columns[0].toLowerCase().trim());

        if (product) {
          this.myControl[productType].product.setValue({ name: product.name, id: product.id }, { emitEvent: false });

          // Set amounts
          this.myControl[productType].amounts.forEach((control, dayIndex) => {
            const amount = parseInt(columns[dayIndex + 2], 10);
            control.setValue(isNaN(amount) ? 0 : amount);
          });
        } else {
          this.notificationService.showNotification("error", `Product '${columns[0]}' not found in products`)
        }
      });
      // Only parse if not empty
      if (this.importJsonData && this.importJsonData.trim() !== "") {
        this.importedJsonData = JSON.parse(this.importJsonData);
      } else {
        this.importedJsonData = null;
        this.notificationService.showNotification("error", "No JSON data to import");
      }
      // // this.importJsonData = "";

      // // Find products and update amounts
      // Object.keys(this.importedJsonData).forEach((productType) => {
      //   const product = this.importedJsonData[productType];
      //   const foundProduct = this.products.find((p) => p.name.toLowerCase().trim() === product.name.toLowerCase().trim());

      //   if (foundProduct) {
      //     this.menuItems[productType]["product"] = foundProduct;
      //     this.menuItems[productType]["amounts"] = product.amounts || Array(5).fill(0);
      //     this.myControl[productType].setValue(foundProduct, { emitEvent: false });
      //   } else {
      //     console.warn(`Product ${product.name} not found in products`);
      //   }
      // });


    } catch (error) {
      console.error('Error parsing JSON:', error);
      this.notificationService.showNotification("error", "Error parsing JSON")
    }
  }

  getCategories(stockingSettings) {
    return stockingSettings ? Array.from( new Set(Object.keys(stockingSettings.productTypes).map((key) => stockingSettings.productTypes[key]))).sort((a, b) => a.localeCompare(b)) : [];
  }

  getProductNameInCategory(category, stockingSettings, menu) {

    const productTypeMapping = stockingSettings.productTypes;

    const productTypesInCategory = Object.keys(productTypeMapping).filter((productType) => productTypeMapping[productType] === category);

    // Find products in menu
    const productsInMenu = Object.keys(menu).sort((a,b) => a.localeCompare(b)).filter(key => productTypesInCategory.includes(key)).map(key => menu[key].product? menu[key].product.name: "NO PRODUCT");

    return productsInMenu;
  }

  getProduct(productType, menuItems) {
    const product = this.myControl[productType].product.value ? menuItems.allProducts.find((p) => p.id === this.myControl[productType].product.value.id) : null;

    return product ? product : "";
  }


  getTotalsForCategoryPerDay(category, day, menuItems) {
    const total = Object.keys(menuItems.productTypes).filter((productType) => menuItems.productTypes[productType] === category).reduce((acc, productType) => {
      const amount = this.myControl[productType].amounts[day].value > 0 ? this.myControl[productType].amounts[day].value : 0;
      return acc + amount;
    }, 0);

    return total;
  }

  getTotalsForCategoryPerType(productType) {
    const total = this.myControl[productType].amounts.reduce((acc, amount) => {
      return acc + (amount.value > 0 ? amount.value : 0);
    }, 0);
    return total;
  }

  getTotalForCategory(category, menuItems) {
    return new Array(5).fill(0).reduce((acc, _, day) => {
      return acc + this.getTotalsForCategoryPerDay(category, day, menuItems);
    }, 0);
  }

  totals = {}

  onAmountChange(event, category, productType, day, menuItems) {
    
    this.isChanged = true;
    this.haveChanges.emit(true);
    this.amountChanged(event, category, productType, day, menuItems);
  }

  amountChanged(event, category, productType, day, menuItems) {

    this.isChanged = true;

    // Calculate totals for days
    const totalsForDays = new Array(5).fill(0).map((_, day) => {
      return this.getTotalsForCategoryPerDay(category, day, menuItems);
    });

    this.totals['categories'] = this.totals['categories'] || {};
    this.totals['categories'][category] = totalsForDays || [0, 0, 0, 0, 0];

    // Calculate total for productType
    const totalForProductType = this.myControl[productType].amounts.reduce((acc, control) => {
      return acc + (control.value > 0 ? control.value : 0);
    }, 0);

    this.totals['productTypes'] = this.totals['productTypes'] || {};
    this.totals['productTypes'][productType] = totalForProductType;

    const categories = [...new Set(Object.values(menuItems.settings['productTypes']))]

    // Grand totals
    this.totals['grandTotal'] = {
      categories: {},
      all: 0
    }

    categories.forEach((category) => {
      this.totals['grandTotal'].categories[category] = this.totals['categories'][category] ? this.totals['categories'][category].reduce((a, b) => a + b, 0) : 0;
      this.totals['grandTotal'].all += this.totals['grandTotal'].categories[category];
    });

  }

  isGlutenFreeCategory(category, menuItems) {
    const typesInCategory = Object.keys(menuItems.productTypes).filter((productType) => menuItems.productTypes[productType] === category)

    const glutenFree = typesInCategory.filter((productType) => {
      // Find in all products
      const product = menuItems.allProducts.find((p) => this.myControl[productType].product.value ? p.id === this.myControl[productType].product.value.id : false)
      return product ? product.isGlutenFri : false
    })
    return glutenFree.length > 0
  }

  isVegetarCategory(category, menuItems) {
    const typesInCategory = Object.keys(menuItems.productTypes).filter((productType) => menuItems.productTypes[productType] === category)

    const vegetars = typesInCategory.filter((productType) => {
      // Find in all products
      const product = menuItems.allProducts.find((p) => this.myControl[productType].product.value ? p.id === this.myControl[productType].product.value.id : false)
      return product ? product.isVegetar : false
    })
    return vegetars.length > 0
  }



  getDataSource(category, menuItems) {
    return menuItems ? Object.keys(menuItems.products).filter((key) => menuItems.products[key]['category'] === category) : [];
  }

  productSelected(product) {
    this.menuItems[product.productType]["product"] = product
  }

  saveMenu(menuItems) {

    const menuToSave = {};

    const { productTypes } = menuItems;

    Object.keys(productTypes).forEach((productType) => {
      if (menuToSave['data'] === undefined) menuToSave['data'] = {};
      menuToSave['data'][productType] = {
        product: this.myControl[productType].product.value && this.myControl[productType].product.value.id ? {
          id: this.myControl[productType].product.value.id,
          name: this.myControl[productType].product.value.name
        } : null,
        amounts: this.myControl[productType].amounts.map((control) => control.value > 0 ? control.value : 0)
      }
    });

    menuToSave['locked'] = this.locked;
    menuToSave['updated'] = moment().format("YYYY-MM-DD HH:mm:ss");
    menuToSave['unix'] = moment().unix();
    menuToSave['week'] = Number(this.week.format('WW'));
    menuToSave['year'] = Number(this.week.format('YYYY'));
    menuToSave['unixStartOfWeek'] = this.week.unix();
    menuToSave['changeReason'] = this.changeReason.trim() || null;


    this.stockingService.saveMenu(this.week.format('WW'), this.week.format('YYYY'), menuToSave
    ).then(() => {
      this.isChanged = false;
      this.changeReason = '';
      this.haveChanges.emit(false);
      this.notificationService.showNotification("success", "Menu saved")
      this.updateMenuList();
    }).catch((error) => {
      this.notificationService.showNotification("error", "Error saving menu")
    })
  }

  openDialog() {
    const dialogRef = this.dialog.open(MenuCopyDialogComponent, {
      width: '600px', // Set the width of the dialog
    });

    const dialogRefSub = dialogRef.afterClosed().subscribe((result) => {
      if (result) {

        console.log({ result });
        this.copyMenu(result.type, result.fromDays, result.toDays, result.oneToManyDays, result.week, result.year)
      }

      dialogRefSub.unsubscribe();
    });
  }

  onLockMenu(menuItems) {
    this.locked = !this.locked;

    if (this.locked) {
      this.lockMenu();
      this.saveMenu(menuItems);
      this.notificationService.showNotification("warning", "Menu locked")
    } else {
      this.unLockMenu(menuItems);
      this.notificationService.showNotification("success", "Menu unlocked")
    }
  }

  lockMenu() {
    this.locked = true;
    Object.keys(this.myControl).forEach((productType) => {
      this.myControl[productType].product.disable();
      this.myControl[productType].amounts.forEach((control) => control.disable());
    });
  }

  unLockMenu(menuItems) {
    this.locked = false;
    // Unlock all controls unless holiday
    Object.keys(this.myControl).forEach((productType) => {
      this.myControl[productType].product.enable();
      this.myControl[productType].amounts.forEach((control, index) => {
        if (!menuItems.hollydaysThisWeek[index]) {
          control.enable();
        }
      });
    });

  }


  copyMenu(type, fromDays, toDays, oneToManyDays, week, year) {
    this.isChanged = true;
    this.haveChanges.emit(true);

    // get values from week and year from result
    const startOfWeek = moment(this.week).startOf('week').add(1, "day").startOf('day')
    const startOfCopyWeek = moment().year(year).week(week).startOf('week').add(1, "day").startOf('day')

    if (type == 'amountsAndProducts' || type == 'amounts') {
      fromDays = [true, true, true, true, true]
      toDays = [true, true, true, true, true]
    }

    const getMenuSubscription = this.stockingService.getMenu$(startOfCopyWeek.format('WW'), startOfCopyWeek.format('YYYY')).subscribe((menu) => {
      getMenuSubscription.unsubscribe();
      if (type == 'oneToManyDays') {
        let copyAmounts = {}
        Object.keys(menu['data']).forEach((productType) => {
          copyAmounts[productType] = menu['data'][productType].amounts[oneToManyDays] || 0
        })

        console.log({ copyAmounts, fromDays, toDays, menu: menu['data'] })

        toDays.forEach((day, index) => {
          if (day){
            Object.keys(this.myControl).forEach((productType) => {
              if(this.myControl[productType].amounts[index].enabled) {
                console.log("Copying to ", { productType, index, amount: copyAmounts[productType] })
                this.myControl[productType].amounts[index].setValue(copyAmounts[productType], { emitEvent: true });
              }
            })
          }
        })
      }

      Object.keys(menu['data']).forEach((productType) => {
        const product = menu['data'][productType]
        if (type == 'amountsAndProducts' || type == 'amounts' || type == 'dayAmount') {
          // Amounts
          fromDays.forEach((day, index) => {
            if (day && toDays[index] && this.myControl[productType].amounts[index].enabled) {
              
              this.myControl[productType].amounts[index].setValue(product.amounts[index], { emitEvent: true });
              // this.menuItems[productType]["amounts"][index] = product.amounts[index]
            }
          })

        }


        // this.menuItems[productType]["amounts"] = product.amounts
        if (type == 'amountsAndProducts' || type == 'products') {
          // this.menuItems[productType]["product"] = product.product

          this.myControl[productType].product.setValue(product.product, { emitEvent: false })
        }
      })


      this.notificationService.showNotification("success", "Menu copied")
    });

  }


  getExportJsonDataAsTSV() {
    return 0;
    // const header = ['Product Name', '', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
    // let lastCategory = null;
    // const rows = [];

    // this.dataSource.forEach((item) => {
    //   const category = item.category;
    //   const productType = item.type;
    //   const product = this.menuItems[productType].product;
    //   const amounts = this.menuItems[productType].amounts;

    //   if (lastCategory !== null && lastCategory !== category) {
    //     rows.push([]); // Add empty row for new category
    //   }
    //   rows.push([product.name + '\t', ...amounts]);
    //   lastCategory = category;
    // });

    // // Combine header and rows
    // const tsvData = [header, ...rows].map(row => row.join('\t')).join('\n');

    // return tsvData;
  }

  goToWeek(week: number, year: number) {
    console.log({ isChanged: this.isChanged });
    if (this.isChanged) {
      const proceed = confirm('You have unsaved changes! Are you sure you want to switch week and lose your changes?');
      if (!proceed) {
        return;
      }
    }
    console.log({ week, year });
    if (this.week.week() === week && this.week.year() === year) return;
    this.week = moment().year(year).week(week).add(1, 'day').startOf('day');
    this.router.navigate(['/dashboard', 'menus', year, week], { replaceUrl: false });


    this.updateMenuList();
    this.updateMenu();


  }

  isActiveWeek(week: number, year: number): boolean {
    return this.week.week() === week && this.week.year() === year;
  }

  toPreviewList(data) {
    if (!data) return [];
    return Object.keys(data).map((key) => {
      return {
        productType: key,
        productName: data[key].product ? data[key].product.name : 'No product',
      }
    }).sort((a, b) => a.productType.localeCompare(b.productType));
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.isChanged) {
      $event.returnValue = true;
    }
  }

  canDeactivate(): boolean {
    if (this.isChanged) {
      return confirm('You have unsaved changes! Are you sure you want to leave?');
    }
    return true;
  }

}
